module.exports = __webpack_public_path__ + "img/vippack_dfod.656ecb16.png";